<template>
    <base-overlay
        :is-open="shouldShowViewAll"
        @overlayClose="handleCloseViewAll"
    >
        <template v-slot:header>
            <div class="flex w-full justify-between items-center relative">
                <!-- <reset-button
                    class="absolute left-0"
                    v-if="userMadeSelection"
                /> -->
                <h1 class="flex-1 text-center text-base font-semibold -mr-[19px] pointer-events-none">
                    <span class="text-black">
                        {{ totalSelectionsMade }} / {{ totalSteps }} {{ $t('COMPLETED') }}
                    </span>
                </h1>

                <close-button
                    class="absolute right-0"
                    @click="handleCloseViewAll"
                />
            </div>
        </template>

        <template v-slot:content>
            <ul class="w-full">
                <swiper-list-item
                    v-for="(group, index) in visibleGroupsForList"
                    :key="group"
                    :is-view-all="true"
                    :item-data="group"
                    role="button"
                    @click="openGroupOverlay(group)"
                    :class="[
                        { 'border-b border-gray-DFDFDF': index !== visibleGroupsForList.length }
                    ]"
                    class="py-3 pl-6 pr-4"
                />
            </ul>
        </template>
    </base-overlay>
    <base-overlay
        :is-open="showGroupOverlay"
        :show-color-controls="shouldShowColorControls"
        @overlayClose="handleCloseGroup"
    >
        <template v-slot:header>
            <!-- <h1
                v-if="selectedGroup"
                class="flex-1 text-center text-base font-semibold"
            >
                {{ selectedGroup.name }}
            </h1> -->
            <div class="flex w-full justify-between items-center relative">
                <!-- width ensures h1 text is centered -->
                <reset-panel-button
                    class="w-[18px] absolute left-0"
                />
                <h1 v-if="selectedGroup?.name"
                    class="flex-1 text-center text-base font-semibold pointer-events-none"
                >
                    {{ selectedGroup.name }}
                </h1>
            </div>
        </template>

        <template v-slot:content>
            <div class="flex flex-col flex-1 min-h-0">
                <step-options
                    v-if="selectedGroup"
                    :item-data="selectedGroupActual"
                    @applySelections="handleApplySelections"
                />
            </div>
        </template>
    </base-overlay>
</template>

<script>
    import allStores from '../stores/all';

    import BaseOverlay from './BaseOverlay.vue';
    // import ResetButton from './buttons/ResetButton.vue';
    import SwiperListItem from './SwiperListItem.vue';
    import StepOptions from './StepOptions.vue';
    import ResetPanelButton from './buttons/ResetPanelButton.vue';
    import CloseButton from './buttons/CloseButton.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseOverlay,
            // ResetButton,
            SwiperListItem,
            StepOptions,
            ResetPanelButton,
            CloseButton,
        },

        data() {
            return {
                selectedGroup: null,
                isOverlayCloseInProgress: false,
            };
        },

        computed: {
            visibleGroupsForList() {
                return this.customizerStore.buildVisibleGroups({
                    sourceGroups: this.visibleGroups,
                });
            },

            totalSteps() {
                return this.customizerStore.totalSteps;
            },

            selectedGroupActual() {
                // Handle integrated Face/Sole panel special case.
                if (this.selectedGroup?.name === 'Character Stamping'
                    || this.selectedGroup?.name === 'Face/Sole'
                    || this.selectedGroup?.name === 'Stamps') {
                    const characterStampingGroup = this.visibleGroups.find((group) => group.name === 'Character Stamping');
                    const stampsGroup = this.visibleGroups.find((group) => group.name === 'Stamps');

                    const subGroups = {};

                    if (characterStampingGroup) {
                        subGroups.characterStamping = {
                            name: 'Character Stamping',
                            code: 'Character Stamping',
                            placements: characterStampingGroup.placements,
                        };
                    }

                    if (stampsGroup) {
                        subGroups.stamps = {
                            name: 'Stamps',
                            code: 'Stamps',
                            placements: stampsGroup.placements,
                        };
                    }

                    return {
                        name: 'Face/Sole',
                        code: 'Face/Sole',
                        custom: {
                            'v-group-type': 'front',
                        },
                        subGroups,
                    };
                }

                return this.selectedGroup;
            },
            panelHasStickyHeader() {
                const panelsWithStickyHeader = [
                    'Character Stamping',
                    'Paintfill',
                    'Toe Engraving',
                ];

                return panelsWithStickyHeader.includes(this.selectedGroup?.name);
            },

            currentGroupName() {
                return this.customizerStore.currentGroup;
            },

            totalSelectionsMade() {
                return this.customizerStore.totalSelectionsMade;
            },

            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },

            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            selectionsMade() {
                return this.customizerStore.selectionsMade;
            },

            shouldShowViewAll() {
                return this.appStore.shouldShowViewAll;
            },

            userMadeSelection() {
                // return this.customizerStore.userMadeSelection;
                return true;
            },

            showGroupOverlay() {
                return this.appStore.showGroupOverlay;
            },

            shouldShowColorControls() {
                const groupType = this.selectedGroupActual?.custom?.['v-group-type'];

                return this.customizerStore.shouldShowColorControls(groupType);
            },
        },

        methods: {
            getFrontGroup() {
                const characterStampingGroup = this.visibleGroups.find((group) => group.name === 'Character Stamping');
                const stampsGroup = this.visibleGroups.find((group) => group.name === 'Stamps');

                const subGroups = {};

                if (characterStampingGroup) {
                    subGroups.characterStamping = {
                        name: 'Character Stamping',
                        code: 'Character Stamping',
                        placements: characterStampingGroup.placements,
                    };
                }

                if (stampsGroup) {
                    subGroups.stamps = {
                        name: 'Stamps',
                        code: 'Stamps',
                        placements: stampsGroup.placements,
                    };
                }

                return {
                    name: 'Face/Sole',
                    code: 'Face/Sole',
                    custom: {
                        'v-group-type': 'front',
                    },
                    subGroups,
                };
            },
            handleCloseViewAll() {
                this.setShouldShowViewAll(false);
                // $emit('overlayClose')
            },

            handleCloseGroup() {
                if (this.isOverlayCloseInProgress) { return; }
                this.isOverlayCloseInProgress = true;

                // If a nested panel is open, close it first and do not close the group overlay.
                if (this.appStore.hasOpenNestedPanel) {
                    this.appStore.closeNestedPanel();
                    setTimeout(() => { this.isOverlayCloseInProgress = false; }, 300);
                    return;
                }

                this.appStore.setShowGroupOverlay(false);
                this.$emit('close-overlay');
                this.appStore.setShouldShowSummary(false);
                this.isOverlayCloseInProgress = false;
            },

            setShouldShowViewAll(value) {
                this.appStore.setShouldShowViewAll(value);
            },

            openGroupOverlay(group) {
                if (this.customizerStore.isSurefitHubLocked(group.placements)) {
                    return;
                }

                const isFaceSole = group.name === 'Face/Sole' || group.code === 'Face/Sole';

                // Use unified Face/Sole panel data.
                this.selectedGroup = isFaceSole ? this.getFrontGroup() : group;

                this.customizerStore.addGroupToSeen(isFaceSole ? 'Face/Sole' : group.name);

                this.appStore.setShowGroupOverlay(true);

                this.customizerStore.setCurrentGroup(isFaceSole ? 'Face/Sole' : group.name);
            },

            previousSelectionWasMade(groupName) {
                const currentGroupIndex = this.visibleGroups.findIndex((group) => group.name === groupName);

                if (currentGroupIndex === 0) {
                    return true;
                }

                const previousGroup = this.visibleGroups[currentGroupIndex - 1];

                return this.selectionsMade.includes(previousGroup.name) && this.hasBeenSeen(previousGroup.name);
            },

            isCurrentGroup(groupName) {
                return this.currentGroup === groupName;
            },

            enableNextStep() {
                // Update swiper current slide in the background if the overlay is open
                if (this.shouldShowViewAll) {
                    const nextButton = document.getElementsByClassName('swiper-button-next')[0];

                    setTimeout(() => {
                        nextButton.click();
                    }, 200);
                }
            },

            hasBeenSeen(groupName) {
                return this.customizerStore.groupsSeen.includes(groupName);
            },

            handleApplySelections() {
                this.showGroupOverlay = false;
            },
        },
    };
</script>
